import { useOpQuery } from 'utils/customHooks/useOpQuery';
import { getOpParams } from 'utils/getOpParams';

export const usePartnerInfo = () => {
  const { orgId } = getOpParams();

  const { data: orgFeatures } = useOpQuery({
    apiEndpointName: 'listOrgFeatures',
    parameters: [Number(orgId)],
    select: (data) => data.json.data,
    suppressErrorMessage: true,
  });
  const isAccessPartner = Boolean(
    orgFeatures?.some((feature) => feature.code === 'subOrgs'),
  );

  const isVideoPartner = Boolean(
    orgFeatures?.some((feature) => feature.code === 'subOrgsVideo'),
  );

  return {
    isAccessPartner,
    isVideoPartner,
  };
};
